<template>
  <div id="validacion-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Validacion Historico</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <grid-validacion-historico
                      :documentoId="id"
                      :tipeView="tipeView"
                    ></grid-validacion-historico>
                    <!-- TERMINO DATOS DE VISITA -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import GridValidacionHistorico from "@/modules/impresion/views/validaciones/GridValidacionHistorico.vue";
import axios from "axios";

export default {
  name: "validacion-registra",
  components: {
    GridValidacionHistorico,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipo: "",
  },

  data: () => ({
    id: "",
    documentoId: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {
    this.documentoId = this.$route.params.idValidacion;
    this.id = this.idDocumentoValidacion;
  },
  created() {},

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
